import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { clientDocToServerMap } from 'app/businessRules';
import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { storeDoc as storeDocActions } from '../actions';
import { STORE_DOC } from '../constants/actionTypes';
import { saveDoc, updateDoc } from '../repository';


function *_storeDoc(action) {
    const {utrac, formData} = action;
    yield put(loadDataAction('storeDoc'));
    const payload = clientDocToServerMap(formData);

    try {
        let doc;
        if (formData.id) {
            doc = yield call(updateDoc(utrac, payload));
        } else {
            doc = yield call(saveDoc(utrac, payload));
        }
        yield put(storeDocActions.success(doc));
        yield put(loadDataSuccessAction('storeDoc', 'doc.form.save.success'));
    } catch (error) {
        yield put(storeDocActions.error(error));
        yield put(loadDataErrorAction('storeDoc', {response: error.response, body: error.body, titleId:'doc.form.save.failed'}, action));
    }

}


export function *storeDoc() {
    yield takeLatest(STORE_DOC.REQUEST, _storeDoc);
}